import Typography from "@mui/material/Typography";
import Sponsors from "./Sponsors";
import React from "react";
import {useMediaQuery} from "@mui/material";
import FormLinks from "./FormLinks";

export default function HomeCardContent() {

    let headingSize = 'h5'
    if (useMediaQuery('(max-width:1100px)'))
        headingSize = 'h6'

    return (
        <div>
            <Typography sx={{fontWeight: 'bold'}} variant={headingSize} component="div">
                2026 Third Altenburg International Baroque Trumpet Competition
            </Typography>
            <Typography variant="h6" color="text.secondary" >
                19-22 November, 2026, Trumpet Museum, Bad Säckingen, Germany

            </Typography>

            <FormLinks/>

            <Typography variant="body1" sx={{marginTop: 1.5}}>
                The 2026 Third Altenburg International Baroque Trumpet Competition is a four-day event to be held in Bad Säckingen, Germany. The event consists of concerts, master classes, and a competition—all related to the baroque trumpet.
            </Typography>

            <Typography sx={{fontWeight: 'bold', marginTop: .75}} variant={"h6"} color="text.lighter">
                Registration has been extended to July 15th
            </Typography>

            <Sponsors/>
        </div>
    )
}